import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"

type Props = {
  rank: number
  label: string
  color: string
}

export const RankingBadge = ({ rank, label, color }: Props) => {
  const numberTextColor = color === "negative" ? "text-white" : "text-black"

  return (
    <Badge variant="outline" className={cn("whitespace-nowrap px-1", `border-${color}`)}>
      <div className="flex flex-row items-center gap-1.5">
        <div
          className={cn(
            "flex h-5 w-5 shrink-0 items-center justify-center rounded-sm p-0",
            `bg-${color}`,
          )}
        >
          <span className={cn("text-[10px] leading-none font-semibold", numberTextColor)}>
            {`#${rank}`}
          </span>
        </div>
        <span className="text-xs text-muted-foreground">{label}</span>
      </div>
    </Badge>
  )
}
